import { TripFolderInput } from '../../lib/types/models/trip-folder/trip-folder-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripFolder(data: TripFolderInput) {
  return restApiClient.url(constructApiUrl(API.tripFolder.create.url, null)).post(data)
}
